import axios from "axios";
// import userApi from "../api/userApi.js";
import { config } from "../config/config.js";

const serviceURL = config.serviceURL;
const casLoginBaseURL = config.casLoginBaseURL;
let casJwtIssuingLambdaURL = config.casJwtIssuingLambdaURL;
const encodedServiceURL = encodeURIComponent(serviceURL);
const casLoginURL = `${casLoginBaseURL}?service=${encodedServiceURL}`;


export default async function casRouteGuard(to, from, next) {
  // Skip login route
  if (to.path === '/login') {
    return next();
  }

  // Get botName from Vue route query (works with hash routing)
  const chatbot = to.query.botName;

  // Special case: LTI/Canvas auth token (direct token in URL)
  const ltiAuthToken = to.query.ltiAuthToken;
  if (ltiAuthToken && chatbot) {
    localStorage.setItem("jwt-" + chatbot, decodeURIComponent(ltiAuthToken));
    return next();
  }

  // Check if there's a ticket from CAS (user returning from login)
  const ticket = to.query.ticket;
  if (ticket) {
    // Redirect to login page to process the ticket
    return next({
      path: '/login',
      query: {
        botName: chatbot,
        ticket: ticket,
        returnTo: to.fullPath
      }
    });
  }

  // No ticket, no LTI token - just let through
  // Auth enforcement happens in axios interceptor on 401
  return next();
}

// These are exported for testing purposes so we can stub them in sinon
export const routeGuardUtils = {
  async validateAndProcessJwt(jwtEncoded, next, chatbot) {
    const jwt = this.decodeJWT(jwtEncoded)

    if (this.isJwtTokenExpired(jwt)) {
      // console.log("JWT is expired.");
      localStorage.clear();
      return false;
    }

    // console.log("JWT is not expired. Continue to process route.");

    try {
      // Set JWT so API can make a call to get the current user
      localStorage.setItem("jwt-"+chatbot, jwtEncoded);
      localStorage.setItem("username", jwt.username);
      localStorage.removeItem("redirectedToCas"); //Clear the retry attempts
      
      const savedFullPath = localStorage.getItem("savedFullPath");
      if (savedFullPath) {
        const savedUrl = window.location.origin + savedFullPath;
        localStorage.removeItem("savedFullPath");
        // console.log("Loading", savedUrl);
        window.location = savedUrl;
      } else {
        // console.log("No savedFullPath, staying on current page");
      }
      return true;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.log("User not found in system since we got a 404. Send to userNotInSystem page.");
        localStorage.clear();
        return next('/userNotInSystem');
      }
      console.log("Error fetching current user:", error);
      localStorage.clear();
      return false;
    }
  },

  async processTicket(ticket) {
    // console.log("Ticket found in URL:", ticket);
    try {
      const jwt = await this.getJwtTokenWithCasTicket(ticket);
      return jwt ? jwt : null;
    } catch (error) {
      console.error("Error processing ticket:", error);
      return null;
    }
  },

  async getJwtTokenWithCasTicket(ticket) {
    let queryParams = `?serviceUrl=${encodeURIComponent(serviceURL)}&ticket=${encodeURIComponent(ticket)}`;
    // console.log(`Get JWT Token from JWT Issuing Lambda with query params: ${queryParams}`);
    // console.log(`Using service URL: ${serviceURL}`);
    try {
      // Remove ticket from URL cleanly
      const url = new URL(window.location.href);
      url.searchParams.delete('ticket');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      // console.log(`Call JWT Lambda axios.get: ${casJwtIssuingLambdaURL}${queryParams}`)
      const response = await axios.get(`${casJwtIssuingLambdaURL}${queryParams}`);
      // console.log("JWT Lambda Response is", response);
      return response.data.token;
    } catch (error) {
      console.error("Error getting JWT from Lambda using CAS ticket:", error);
      throw error;
    }
  },


  decodeJWT(token) {
    const tokenParts = token.split(".");
    const payload = tokenParts[1];
    return JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")));
  },

  isJwtTokenExpired(jwt) {
    const exp = jwt.exp;
    return !exp || Math.floor(Date.now() / 1000) >= exp;
  }
};

